import React from "react";

function Curated() {
	return (
		<div className="container">
			<div className="container--inner">
				<h1>ArcSpan Curated</h1>
			</div>
		</div>
	);
}

export default Curated;
